import { useEffect, useState } from "react";
import {
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

export default function Home() {
  const [activeSection, setActiveSection] = useState("home");

  // 🔹 Detect active section on scroll
  useEffect(() => {
    const sections = ["home", "about", "portfolio", "contact"];

    const handleScroll = () => {
      const scrollPos = window.scrollY + 200;

      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (
          section &&
          scrollPos >= section.offsetTop &&
          scrollPos < section.offsetTop + section.offsetHeight
        ) {
          setActiveSection(id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navClass = (id) =>
    `hover:border-b-2 border-green-500 ${
      activeSection === id ? "border-b-2" : ""
    }`;

  return (
    <div
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center px-4 scroll-smooth"
    >
      {/* soft glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-500/10 via-blue-500/10 to-purple-500/10 blur-3xl" />

      <div className="relative z-10 text-center">
        <h1 className="text-6xl md:text-7xl font-bold mb-4">
          Ebin Benny
        </h1>

        <p className="text-xl md:text-2xl">
          I'm a passionate{" "}
          <span className="underline decoration-green-500">
            Software Developer
          </span>{" "}
          from Kerala, India
        </p>

        {/* Navigation */}
        <nav className="flex space-x-6 mt-8 text-lg font-medium justify-center">
          <a href="#home" className={navClass("home")}>Home</a>
          <a href="#about" className={navClass("about")}>About</a>
          <a
            href="/Resume.pdf"
            download
            className="hover:border-b-2 border-green-500"
          >
            Resume
          </a>
          <a href="#portfolio" className={navClass("portfolio")}>Portfolio</a>
          <a href="#contact" className={navClass("contact")}>Contact</a>
        </nav>

        {/* Social Links */}
        <div className="flex space-x-4 mt-8 justify-center">
          {/* WhatsApp */}
          <a
            href="https://wa.me/919036668177"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="p-3 bg-gray-800 rounded-full hover:bg-green-500 transition"
          >
            <FaWhatsapp />
          </a>

          {/* Gmail */}
          <a
            href="mailto:ebinbenny055@gmail.com"
            aria-label="Gmail"
            className="p-3 bg-gray-800 rounded-full hover:bg-green-500 transition"
          >
            <FaEnvelope />
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/__ebi_____?igsh=MWtsdDNqcDR3eWE5eg=="
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="p-3 bg-gray-800 rounded-full hover:bg-green-500 transition"
          >
            <FaInstagram />
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.instagram.com/__ebi_____?igsh=MWtsdDNqcDR3eWE5eg=="
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="p-3 bg-gray-800 rounded-full hover:bg-green-500 transition"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </div>
  );
}
